import { tap } from 'lodash/fp';
import * as designBuilderApi from '../api/designBuilder';
import estimateLoaded from './estimateLoaded';
import itemCopied from './itemCopied';
import loaded from './loaded';
import loading from './loading';
import globalError from './globalError';
import smoothScroll from '../helpers/smoothScroll';
import getElementHeight from '../helpers/getElementHeight';

const copyItems = (itemId, numberOfCopies) => (dispatch, getState) => {
  dispatch(loading());
  const { uiState, entities } = getState().estimateBuilder;
  const { selectedEstimate } = uiState;
  const { containers } = entities;
  const { allIds, byId } = containers;

  const containerId = allIds.find(givenId => byId[givenId].items.indexOf(itemId) !== -1);

  return designBuilderApi
    .copyItems(selectedEstimate, itemId, numberOfCopies)
    .then((response) => {
      dispatch(estimateLoaded(response.data));
      dispatch(itemCopied(containerId));
      smoothScroll(`#scrollbottom-${containerId}`, getElementHeight('.itemCard') * numberOfCopies);
    })
    .then(tap(() => dispatch(loaded())))
    .catch(err => dispatch(globalError({ err })));
};

export default copyItems;
